// Shared empty-state treatment for the agency portal lists. The portals shipped with an
// emoji inside a circle as the "no data" illustration; BRAND.md bans emoji as icons, so
// every tab uses this one vector well instead.
import { IoCheckmarkCircleOutline, IoCloseCircleOutline, IoHourglassOutline } from "react-icons/io5";

const Glyph = ({ name }) => {
  const Icon = { pending: IoHourglassOutline, accepted: IoCheckmarkCircleOutline, declined: IoCloseCircleOutline }[name];
  const tint = { pending: "var(--mx-warn)", accepted: "var(--mx-ok)", declined: "var(--mx-pink)" }[name];
  return <Icon size={34} style={{ color: tint }} aria-hidden="true" />;
};

const EmptyState = ({ glyph, title, detail }) => (
  <div style={{ padding: "56px 20px", textAlign: "center" }}>
    <div
      style={{
        width: 80,
        height: 80,
        margin: "0 auto 16px",
        borderRadius: "50%",
        border: "1px solid var(--mx-border)",
        background: "var(--mx-accent-soft)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Glyph name={glyph} />
    </div>
    <div style={{ color: "var(--mx-text)", fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{title}</div>
    <div style={{ color: "var(--mx-text-2)", fontSize: 14, maxWidth: 300, margin: "0 auto", lineHeight: 1.5 }}>
      {detail}
    </div>
  </div>
);

export default EmptyState;
